import React, { useRef } from 'react';
import { isiOS } from '../lib/Device';
import useAppMode from '../lib/hook/config/useAppMode';

export interface AudioPlayerProps {
  autoPlay?: boolean;
  className?: string;
  downloadable?: boolean;
  onPlay?: () => void;
  url: string;
}

const AudioPlayer = React.forwardRef<HTMLAudioElement, AudioPlayerProps>(
  (props: AudioPlayerProps, ref) => {
    const {
      autoPlay = false,
      className,
      downloadable = false,
      onPlay,
      url,
    } = props;

    const playedRef = useRef(false);

    const onAudioPlayed = () => {
      if (!playedRef.current && onPlay) {
        playedRef.current = true;
        onPlay();
      }
    };

    const { isEmbeddedMode } = useAppMode();

    return (
      <audio
        ref={ref}
        autoPlay={autoPlay && !isiOS()}
        className={className}
        controls
        controlsList={
          !downloadable || isEmbeddedMode ? 'nodownload' : undefined
        }
        onContextMenu={(e) => {
          if (!downloadable) e.preventDefault();
        }}
        onPlay={onAudioPlayed}
        preload={isiOS() ? 'none' : 'metadata'}
        src={url}
        style={{ width: '100%' }}
      />
    );
  }
);

export default AudioPlayer;
